module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2d",
    attrs: {
      "id": "intro1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Text/contents#intro"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('h2', {
    staticClass: "h2a0",
    attrs: {
      "id": "heading_id_2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/contents#intro"
    }
  }, [_vm._v("Prayer—It’s Not about You")])]), _vm._v(" "), _c('h5', {
    staticClass: "image-centera",
    attrs: {
      "id": "heading_id_3"
    }
  }, [_c('img', {
    staticClass: "imagefix",
    attrs: {
      "alt": "image",
      "src": "Images/ART_common1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("“I")]), _vm._v("t’s not about you.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rn1"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/notes#n1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("The opening line of "), _c('i', [_vm._v("The Purpose Driven Life")]), _vm._v(" by Rick Warren has also been the essence of our "), _c('i', [_vm._v("Cat and Dog Theology")]), _vm._v(" book and seminars. Why is so much emphasis being given to this theme today? Because the church needs to hear it! The twenty-first-century church has been fed a diet of "), _c('i', [_vm._v("me-ism")]), _vm._v(", a concept born in the sinful selfishness of the heart of human-kind in the garden of Eden that’s grown steadily ever since.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("If we remember the proverb “Train up a child in the way he should go, and when he is old he will not turn from it” (Proverbs 22:6 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NIV")]), _vm._v("), it’s easy to see how we got here. The church has existed more than two thousand years, yet in the last fifty years or so, our diet of strict me-ism has affected our attitudes, our way of life, our theology, and especially our prayers.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("All Christians know they ought to pray. Almost all Christians do pray—sometimes. But there seems to be a problem with prayer. We don’t find it seems to make a significant difference; that is, prayer doesn’t seem to really work.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v("Why? Much of the answer lies in the fact that the hearts and minds of today’s Christians have been steeped in Cat Theology. Let us remind you of the difference between Cat Theology and Dog Theology.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("It’s been said that dogs have masters and cats have staff. That is, dogs live to please their masters, while self-centered cats think their masters exist to please them. Cats and dogs see life from different vantage points and therefore come to two different conclusions about the same information.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Dogs look at all their masters do for them and think, "), _c('i', [_vm._v("You feed me. You pet me. You shelter me. You love me")]), _vm._v(". "), _c('i', [_vm._v("YOU MUST BE GOD!")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("But cats look at the same information and think, "), _c('i', [_vm._v("You feed me. You pet me. You shelter me. You love me. I MUST BE GOD!")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("It’s easy to see the difference. Cat Christians think everything is about them. They live at the center of their own universe. That’s why UnveilinGLORY (the parent ministry of Cat and Dog Theology) has said we need a Copernican revolution in the church—we need to quit thinking everything revolves around us! Scripture is clear on this topic: “When you ask, you do not receive, because you ask with wrong motives, that you may spend what you get on your pleasures” (James 4:3 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NIV")]), _vm._v(").")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("The Bible tells us about people who prayed and the sun stood still, prayers that brought healing, caused rain in the midst of drought, overthrew armies, created an endless supply of oil, raised people from the dead, and Jesus even offered us ability to move mountains. But our reality is, we don’t see mountains moving, we don’t see the dead raised to life, there is no endless oil for us, no armies overthrown, no downpour "), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v("of rain after a dry spell, the sick don’t seem to be healed in any immediate fashion, and the earth doesn’t stand still just because we pray that it will.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Yet it sounds heretical to say that prayer doesn’t work. So what do we do?")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Too often we live in a half-believing fantasy, a make-believe quasi world. We believe in our heart that our prayers do "), _c('i', [_vm._v("something")]), _vm._v(", even though the real world doesn’t seem to be moved by it. We feel guilty if we don’t pray, but we often feel like helpless wimps when we do.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Yes, there is a problem with our prayers. But without a doubt the Bible teaches us to pray without a doubt, even though our experience seems to deny the teaching.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytextb"
  }, [_c('span', [_vm._v("This book attempts to resolve some of this dilemma. We hope to give some direction and correction to our prayer lives, because often the problem with prayer is the "), _c('i', [_vm._v("pray-er")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent"
  }, [_c('span', [_vm._v("•    Sometimes the problem is our heart.")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent"
  }, [_c('span', [_vm._v("•    Sometimes the problem is our intent.")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent"
  }, [_c('span', [_vm._v("•    Sometimes the problem is our focus.")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent"
  }, [_c('span', [_vm._v("•    Sometimes the problem is our thinking.")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent"
  }, [_c('span', [_vm._v("•    Sometimes the problem is our wording.")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent"
  }, [_c('span', [_vm._v("•    Sometimes the problem is our relationships.")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindentb"
  }, [_c('span', [_vm._v("•    Sometimes the problem is our faith.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("In other words, "), _c('i', [_vm._v("we")]), _vm._v(" are the problem with prayer. The problem is us.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Before we begin, we need to warn you: this is not a quick-fix book. There are no magic formulas or words that make prayer work. The truth is we "), _c('i', [_vm._v("can’t")]), _vm._v(" make prayer work any more than we can make a river flow. God made rivers to flow, and He made prayer to work. We can only direct you to the river "), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("so you can get in it. We can only direct you to biblical prayer so you can get in its flow.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("But much of the direction we will give is how to correct our focus on ourselves. Cats are praying about and for themselves and wondering why they don’t get answers like the Dogs do. Perhaps what we’re trying to say is that too often when we pray, all God hears is “MEow,” when what moves Him to action is hearing a loud “BARK!” (Being All-Reliant on the King).")])]), _vm._v(" "), _c('h6', {
    staticClass: "bodytext-right",
    attrs: {
      "id": "heading_id_4"
    }
  }, [_vm._v("—The authors")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-681cbd1a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/introduction.vue
// module id = 69
// module chunks = 0